export default __webpack_public_path__ + "static/media/importIO.6b8e0ddf.gif";